import React, { useState, useEffect } from "react";
import {
  Select,
  MenuItem,
  CircularProgress,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Line,
  Legend,
} from "recharts";
import PatientVitalStatsIntro from "../shared/PatientVitalStatsIntro";
import PatientA1C from "../shared/PatientA1C";

const Timeline = ({ selectedPatient, vitalSigns }) => {
  const [selectedVitalSign, setSelectedVitalSign] = useState(null);
  const [loading, setLoading] = useState(false);

  const groupedVitalSigns = (vitalSigns || []).reduce((acc, vital) => {
    vital.components.forEach((component) => {
      if (
        component.code !== "Systolic blood pressure" &&
        component.code !== "Diastolic blood pressure"
      ) {
        const key = `${component.code}-${component.unit}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push({
          value: component.value,
          unit: component.unit,
          effectiveDateTime: vital.effectiveDateTime,
        });
      }
    });
    return acc;
  }, {});

  // const dropdownOptions = [
  //   ...Object.keys(groupedVitalSigns).map((key) => {
  //     const [code, unit] = key.split("-");
  //     return { code, unit, key };
  //   }),
  //   { code: "Blood Pressure", unit: "mm[Hg]", key: "bloodPressure" },
  // ];

  const dropdownOptions = [
    { code: "Vital Stats Short-Form", key: "vitalStats" },
    { code: "Threshold Chart (ASC)", key: "thresholdAsc" },
    { code: "Threshold Chart (DESC)", key: "thresholdDesc" },
  ];

  const handleSelectChange = (event) => {
    setSelectedVitalSign(event.target.value);
  };

  // const chartData =
  //   selectedVitalSign && selectedVitalSign !== "bloodPressure"
  //     ? groupedVitalSigns[selectedVitalSign].map((entry) => ({
  //         date: new Date(entry.effectiveDateTime).toLocaleString(),
  //         value: entry.value,
  //         unit: entry.unit,
  //       }))
  //     : [];

  const bloodPressureData = vitalSigns
    ? vitalSigns.reduce((acc, vital) => {
        const systolicComponent = vital.components.find(
          (comp) => comp.code === "Systolic blood pressure"
        );
        const diastolicComponent = vital.components.find(
          (comp) => comp.code === "Diastolic blood pressure"
        );

        if (systolicComponent || diastolicComponent) {
          const date = new Date(vital.effectiveDateTime).toLocaleString();
          acc.push({
            date,
            systolic: systolicComponent ? systolicComponent.value : null,
            diastolic: diastolicComponent ? diastolicComponent.value : null,
          });
        }
        return acc;
      }, [])
    : [];

  useEffect(() => {
    if (vitalSigns === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [vitalSigns]);

  return (
    <div>
      {loading ? (
        <CircularProgress />
      ) : (
        <div>
          <FormControl style={{ width: "300px" }}>
            <InputLabel style={{ color: "white" }}>Vital Signs</InputLabel>
            <Select
              value={selectedVitalSign || ""}
              onChange={handleSelectChange}
              label="Vital Signs"
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#141b25",
                    color: "#FBFEFF",
                  },
                },
              }}
              sx={{
                color: "white",
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ffffff",
                  borderRadius: "12px",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ffffff",
                  borderRadius: "12px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ffffff",
                  borderRadius: "12px",
                },
                ".MuiSvgIcon-root": {
                  fill: "white !important",
                },
              }}
            >
              {dropdownOptions.map((option) => (
                <MenuItem key={option.key} value={option.key}>
                  {option.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedVitalSign === "bloodPressure" &&
            bloodPressureData.length > 0 && (
              <ResponsiveContainer
                width="100%"
                height={300}
                style={{ marginTop: "25px" }}
              >
                <ScatterChart>
                  <CartesianGrid stroke="#d3d3d3" vertical={false} />
                  <XAxis
                    type="category"
                    dataKey="date"
                    tick={{ fill: "white" }}
                    name="Date"
                    tickFormatter={(tick) =>
                      new Date(tick).toLocaleDateString()
                    }
                  />
                  <YAxis type="number" tick={{ fill: "white" }} name="Value" />
                  <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                  <Legend verticalAlign="top" height={36} />
                  <Line
                    type="monotone"
                    dataKey="systolic"
                    stroke="#ff7300"
                    strokeWidth={2}
                    dot={true}
                    name="Systolic"
                  />
                  <Line
                    type="monotone"
                    dataKey="diastolic"
                    stroke="#387908"
                    strokeWidth={2}
                    dot={true}
                    name="Diastolic"
                  />
                  <Scatter
                    name="Systolic"
                    data={bloodPressureData}
                    fill="#ff7300"
                    line
                    dataKey="systolic"
                  />
                  <Scatter
                    name="Diastolic"
                    data={bloodPressureData}
                    fill="#387908"
                    line
                    dataKey="diastolic"
                  />
                </ScatterChart>
              </ResponsiveContainer>
            )}

          {/* {selectedVitalSign !== "bloodPressure" &&
            selectedVitalSign &&
            chartData.length > 0 && (
              <ResponsiveContainer
                width="100%"
                height={300}
                style={{ marginTop: "25px" }}
              >
                <ScatterChart>
                  <CartesianGrid stroke="#d3d3d3" vertical={false} />
                  <XAxis
                    type="category"
                    dataKey="date"
                    tick={{ fill: "white" }}
                    name="Date"
                    tickFormatter={(tick) =>
                      new Date(tick).toLocaleDateString()
                    }
                  />
                  <YAxis
                    type="number"
                    dataKey="value"
                    tick={{ fill: "white" }}
                    name="Value"
                  />
                  <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                  <Line
                    type="monotone"
                    data={chartData}
                    dataKey="value"
                    stroke="#ffffff"
                    strokeWidth={2}
                    dot={true}
                  />
                  <Scatter
                    name="Vital Sign"
                    data={chartData}
                    fill="#8884d8"
                    line
                  />
                </ScatterChart>
              </ResponsiveContainer>
            )} */}

          {selectedVitalSign === "vitalStats" && (
            <div style={{ display: "flex", gap: "70px", marginTop: "20px" }}>
              <PatientVitalStatsIntro
                color="#f5a623"
                testTitle="Blood Pressure"
                testData="132/83"
                unit="mmHg"
                diagnosis="Prehypertension"
                timestamp="05/28/15, 9:13 AM"
              />

              <PatientVitalStatsIntro
                color="green"
                testTitle="Blood Pressure"
                testData="132/83"
                unit="mmHg"
                diagnosis="Prehypertension"
                timestamp="05/28/15, 9:13 AM"
              />
            </div>
          )}

          {selectedVitalSign === "thresholdAsc" && (
            <div style={{ marginTop: "20px", marginLeft: "50px" }}>
              <Typography variant="body1">Threshold Chart (ASC)</Typography>
              <PatientA1C
                ranges={[
                  [0, 120],
                  [120, 140],
                  [140, 180],
                  [180, null],
                ]}
                colors={["#43a047", "#fdd835", "#fb8c00", "#e53935"]}
                labels={[
                  "Normal",
                  "Prehypertension",
                  "Hypertension 1",
                  "Hypertension 2",
                ]}
                userValue={132}
                normalValue={110}
              />
            </div>
          )}

          {selectedVitalSign === "thresholdDesc" && (
            <div style={{ marginTop: "20px", marginLeft: "50px" }}>
              <Typography variant="body1">Threshold Chart (DESC)</Typography>
              <PatientA1C
                ranges={[
                  [180, null],
                  [140, 180],
                  [120, 140],
                  [0, 120],
                ]}
                colors={["#e53935", "#fb8c00", "#fdd835", "#43a047"]}
                labels={[
                  "Hypertension 2",
                  "Hypertension 1",
                  "Prehypertension",
                  "Normal",
                ]}
                userValue={70}
                normalValue={170}
              />
            </div>
          )}

          {/* {selectedVitalSign &&
            chartData.length === 0 &&
            bloodPressureData.length === 0 && (
              <p>No data available for selected vital sign.</p>
            )} */}
        </div>
      )}
    </div>
  );
};

export default Timeline;
